import type { AlertStatus } from "./alert-status.types"

export const formatTimeAgo = (isoString: string): string => {
  const date = new Date(isoString)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)

  if (diffMins < 1) return "just now"
  if (diffMins < 60) return `${diffMins}m ago`
  if (diffHours < 24) return `${diffHours}h ago`
  return `${diffDays}d ago`
}

export const getAlertStatus = (criticalCount: number, warningCount: number): AlertStatus => {
  if (criticalCount > 0) return "action_required"
  if (warningCount > 0) return "attention"
  return "all_clear"
}
